import * as React from 'react';
import { connect } from 'react-redux';
import companyLogo from '../img/home1.svg';
import { Container, Row, Col } from 'reactstrap';
import { mergeStyles } from '@fluentui/react/lib/Styling';
import { FontIcon } from '@fluentui/react/lib/Icon';
import { colors } from '@material-ui/core';
import pic403 from '../../assets/img/403.webp';
const iconClass = mergeStyles({
  fontSize: 25,

  margin: '-8px 5px',
  display: 'flex',
  float: 'right',

});
const hClass = mergeStyles({
  /* 
  height: 24,
  width: 24,
  margin: '-8px 5px',
  display: 'flex',
  float: 'right', */
  fontSize: 20,
  fontWeight: 600,
  marginTop: "23px",
  color: 'red'
});
const pStyle = mergeStyles({
  textAlign: "center",
  fontSize: 14,
  marginTop: "23px"
});
const AccessDenied403 = () => (
  <div >

    <Container className='centerBGpic' style={{
      minHeight: window.innerHeight - 310,
      backgroundImage: 'url( ' + pic403 + ')',
      backgroundRepeat: "no-repeat",
      backgroundPositionX: "140px"
    }}>
    </Container >
    <Row  >
      <Col  >
        <p className={pStyle}>
          <h5 className={hClass}

          >
            کاربر گرامی، شما مجوز مشاهده صفحه مورد نظر را ندارید</h5>

        </p>
        <div   >
          <Row >

            <Col  >
              <div>

                <p className={pStyle}>
                  برای بازگشت به صفحه ی اصلی
                  <a href='/'> اینجا </a>
                  کلیک نمایید.
                </p>

                <p className={pStyle}>
                  لطفا از سیستم خارج و دوباره وارد سامانه شوید
                  برای خروج از سامانه
                  <a href='/signout'> اینجا </a>
                  کلیک نمایید.
                </p>


              </div>
            </Col>



          </Row>
        </div>

      </Col>
    </Row>
  </div>
);

export default connect()(AccessDenied403);
